import type { RegistryWidgetsType } from '@rjsf/utils';
import BooleanWidget from './boolean-widget';
import DatePickerWidget from './date-picker-widget';
import FileUploaderWidget from './file-uploader-widget';
import InputWidget from './input-widget';
import RadioWidget from './radio-widget';
import SelectWidget from './select-widget';

// Map internal RJSF widgets to our own widgets
// https://rjsf-team.github.io/react-jsonschema-form/docs/advanced-customization/custom-widgets-fields/
const widgets: RegistryWidgetsType = {
  TextWidget: InputWidget,
  EmailWidget: InputWidget,
  PasswordWidget: InputWidget,
  TextareaWidget: InputWidget,
  URLWidget: InputWidget,
  SelectWidget: SelectWidget,
  FileWidget: FileUploaderWidget,
  CheckboxWidget: BooleanWidget,
  DateWidget: DatePickerWidget,
  RadioWidget: RadioWidget,
};

export default widgets;
